import React from 'react'
import { Fragment } from 'react'
import Header from './Header'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'

function Layout() {
  return (
  <>
   <Fragment>
            <div id="layout-wrapper">
                <Header />
                <Outlet />
            </div>
            <Footer />
        </Fragment>
  </>
  )
}

export default Layout